// Illustrative example testimonials. Replace with authentic, verified customer feedback before publishing.
export const testimonials = [
  {
    quote:
      "I used to rebuild my session plans from scattered files every week. Having observation sheets, word lists, and planning templates in one collection made my prep feel much more organized.",
    name: "Laura Gómez",
    role: "Speech-Language Pathologist · Mexico",
    photo: "https://cdn.magicpatterns.com/patterns/generated-images/10d88c06-82de-40cd-965d-b39c8d722fa5.jpg",
  },
  {
    quote:
      "The documentation and follow-up templates are what I use most. I adapted them to my own workflow in an afternoon, and my notes are finally in one consistent format.",
    name: "Patricia Herrera",
    role: "Pediatric Speech Therapist · Argentina",
    photo: "https://cdn.magicpatterns.com/patterns/generated-images/8e69972c-0c5e-44a9-b96e-e3fb1a0eccea.jpg",
  },
  {
    quote:
      "The picture card collection and word list organizer save me a lot of preparation time. They're a practical starting point that I can adjust for each child's targets.",
    name: "Diego Ramírez",
    role: "Speech-Language Pathologist · Colombia",
    photo: "https://cdn.magicpatterns.com/patterns/generated-images/41204240-c6cb-47a0-bc4a-b24b377109a8.jpg",
  },
  {
    quote:
      "As a school-based therapist with a big caseload, the session organizers help me keep priorities clear. The family practice sheets make sharing home activities much simpler.",
    name: "Andrea Castillo",
    role: "School-Based Speech Therapist · Chile",
    photo: "https://cdn.magicpatterns.com/patterns/generated-images/cb64262a-ac3e-4d94-89bb-bba1e841f943.jpg",
  },
  {
    quote:
      "After many years in practice, I appreciate that it doesn't try to replace clinical judgment. It's a well-structured reference I keep coming back to when organizing my planning.",
    name: "Margarita Ortiz",
    role: "Senior Speech-Language Pathologist · Spain",
    photo: "https://cdn.magicpatterns.com/patterns/generated-images/325bba4e-e30b-46f7-a664-22cdb4ffbf90.jpg",
  },
];
